import React from "react";
import { Row, Col } from "react-flexbox-grid";
import Typography from "material-ui-next/Typography";
import { CardValue, StyledButton, SelectField } from "components/support";
import Paper from "material-ui-next/Paper";
import Icon from "material-ui-next/Icon";
import Tooltip from "material-ui-next/Tooltip";
import { ProductBatchLabels } from "core/enum";
import _ from "lodash";
import { colors } from "assets";

const label = header => `Importar "${header}" como`;
const value = (columns, header) => {
  const column = columns.find(v => v.header === header);
  return !!column ? column.column : "";
};
const options = () => {
  const labels = Object.keys(ProductBatchLabels).map(v => ({
    label: ProductBatchLabels[v],
    value: v
  }));
  return _.orderBy(labels, ["value"], ["asc"]);
};

const BatchSettings = ({ columns, headers, onChange, onSubmit }) => (
  <Paper elevation={1} className="p-sm mb-md">
    <Typography type="headline">2ª Etapa</Typography>
    <CardValue small>
      Foram encontradas: {headers.length} colunas. Combine-as com os devidos
      campos abaixo:
    </CardValue>
    <Row>
      {headers.map((header, i) => (
        <Col key={header} md={4} sm={6} xs={12}>
          <SelectField
            fullWidth
            label={label(header)}
            value={value(columns, header)}
            options={options()}
            onChange={(event, _value) => onChange(header, _value)}
          />
        </Col>
      ))}
    </Row>
    <Row bottom="xs" className="pl-sm">
      <StyledButton
        label="Enviar"
        primary
        onClick={onSubmit}
        style={{ margin: "12px 0px 0px" }}
      />

      <Tooltip
        key="tooltip-top-default-configuration"
        title="Para utilizar a configuração geral da empresa, não informe PIS, COFINS e Origem"
        placement="top"
      >
        <Icon
          style={{
            fontSize: 20,
            color: colors.primary.dark,
            marginLeft: "4px"
          }}
          className="tooltip-icon"
        >
          info
        </Icon>
      </Tooltip>
    </Row>
  </Paper>
);

BatchSettings.defaultProps = {
  headers: [],
  columns: [],
  onChange: () => {},
  onSubmit: () => {}
};

export default BatchSettings;



// WEBPACK FOOTER //
// ./src/components/app/registration/product/batch/settings/index.js